export function loadImageElement(file: File): Promise<{ img: HTMLImageElement; revoke: () => void }> {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => resolve({ img, revoke: () => URL.revokeObjectURL(url) });
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Bild konnte nicht geladen werden.'));
    };
    img.src = url;
  });
}

/**
 * Skaliert auf die längste Seite `maxDim` herunter (nie hoch) und zeichnet in
 * einen neuen Canvas. iPhone-Fotos können 4000px+ Kantenlänge haben - ohne
 * Downscale würde die spätere OpenCV-Verarbeitung (Speicher/Tempo im
 * WASM-Heap) auf älteren Geräten ins Stocken geraten oder abstürzen.
 */
export function drawScaledToCanvas(img: HTMLImageElement, maxDim: number): HTMLCanvasElement {
  const scale = Math.min(1, maxDim / Math.max(img.naturalWidth, img.naturalHeight));
  const canvas = document.createElement('canvas');
  canvas.width = Math.max(1, Math.round(img.naturalWidth * scale));
  canvas.height = Math.max(1, Math.round(img.naturalHeight * scale));
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Canvas wird von diesem Browser nicht unterstützt.');
  ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
  return canvas;
}

export function canvasToFile(canvas: HTMLCanvasElement, filename: string, mimeType: string, quality?: number): Promise<File> {
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject(new Error('Bild-Export fehlgeschlagen.'));
          return;
        }
        resolve(new File([blob], filename, { type: mimeType }));
      },
      mimeType,
      quality,
    );
  });
}
